module.exports = __webpack_public_path__ + "img/DSC_0302.31d15f60.jpg";